import { renderPageImportsTemplate } from '@next-adapter/templates/renderers/generators/form-admin/admin-page/generate-page.js'
export function generatePage(pascal: string, kebab: string): string {
  return renderPageImportsTemplate({ pascal: pascal, kebab: kebab })
}
